<template>
    <div class="image-slider-container image-slider-container-padding" v-if="images && images.length > 0">
        <transition-group name="list">
            <div v-for="index in indexList" style="height:90%;" v-bind:key="index">
                <div class="main-title-container">
                    <p class="main-title">{{images[index].subTitle ? images[index].mainTitle : null}}</p>
                    <p class="date-text dont-break-out">{{utcStringToLocalDate(images[index].date, date_format)}}</p>
                </div>
                <div class="subtitle-container">
                    <p class="sub-title dont-break-out">{{images[index].subTitle ? images[index].subTitle : images[index].mainTitle}}</p>
                </div>
                <div class="image-container">
                    <img v-if="shouldDisplayMainImg" class="slide-img" :src="images[index].url" @click="onImageClick(images[index].url, images[index].subTitle)"/>
                </div>
            </div>
        </transition-group>
        <p class="slider-number-text">{{images.length == 0 ? 0 : indexList[0] + 1}} of {{images.length}}</p>
        <div class="slider-button-container">
            <div style="width: 100%; height: 100%; position: relative">
                <div class="prev-slide" @click="onPrevSlideClick">
                    <img src="../../assets/back.png" width="18">
                </div>
                <div class="next-slide" @click="onNextSlideClick">
                    <img src="../../assets/next.png" width="18">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Common from '@/utils/Common.vue'
    export default {
        name: "image-slider",
        mixins: [Common],
        props: {
            images: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                indexList : [0],
                shouldDisplayMainImg: true,
                date_format: 'YYYY-MM-DD HH:mm:ss'
            }
        },
        watch: {
            images() {
                this.indexList = [0];
            }
        },
        methods: {
            onPrevSlideClick() {
                var index = this.indexList[0];
                this.indexList.splice(0, 1);

                index--;
                if (index < 0)
                    index = this.images.length - 1;

                this.indexList.push(index);
            },
            onNextSlideClick() {
                var index = this.indexList[0];
                this.indexList.splice(0, 1);

                index++;
                if (index >= this.images.length)
                    index = 0;

                this.indexList.push(index);
            },
            onImageClick(src, url) {
                this.$emit("imageClicked", src, url);
            },
            refreshImage() {
                this.shouldDisplayMainImg = false;
                this.$nextTick(function() {
                    this.shouldDisplayMainImg = true;
                })
            }
        }
    }
</script>

<style scoped>

    .slide-img {
        max-width: 100%;
        max-height: 100%;
        display:block;
        height: auto;
        position: absolute;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right:0;
    }

    .image-slider-container {
        margin: 0;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .image-slider-container-padding {
        padding-top: 10%;
        padding-left: 5%;
        padding-right: 5%;
    }

    .main-title-container {
        position: absolute;
        bottom: 85%;
        width: 90%;
        height: 5%;
    }

    .subtitle-container {
        position: absolute;
        bottom: 80%;
        width: 100%;
        height: 5%;
    }

    .main-title {
        font-family : 'Digital-Serial-Bold';
        font-size: 1em;
        color: rgb(0,255,174);
        position: absolute;
        top:0;
        left:0;
    }

    .sub-title {
        font-family : 'Digital-Serial-Bold';
        font-size: 1em;
        color: rgb(0,255,174);
        position: absolute;
        left: 0;
        display: inline-block;
        width: 90%;
        overflow: hidden;
    }

    .date-text {
        font-family : 'Digital-Serial-Bold';
        font-size: 1em;
        color: rgb(69,100,120);
        position: absolute;
        right: 0;
        display: inline-block;
    }

    .slider-number-text:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

    .slider-number-text {
        display: inline-block;
        vertical-align: middle;
        position: absolute;
        bottom:0;
        height: 10%;
        font-family : 'Digital-Serial-Bold';
        color: rgb(69,100,120);
    }

    .image-container {
        position:absolute;
        bottom: 10%;
        height: 65%;
        width: 90%;
    }

    .slider-button-container {
        display: inline-block;
        width: 100px;
        height: 10%;
        position: absolute;
        right: 5%;
        bottom: 0;
    }

    .prev-slide {
        display: inline-block;
        width: 50%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .next-slide {
        display: inline-block;
        width: 50%;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }

    .slider-button-container img {
        max-width: 100%;
        max-height: 100%;
        display:block;
        height: auto;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        right:0;
        cursor: pointer;
    }

    p {
        margin: 0;
    }

    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }
    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/image-slider/ImageSlider.vue